/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Conflict_HandlingInputs */

const en_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflict handling`)
};

const ar_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معالجة التعارضات`)
};

const bn_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কনফ্লিক্ট হ্যান্ডলিং`)
};

const de_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfliktbehandlung`)
};

const es_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manejo de conflictos`)
};

const fr_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des conflits`)
};

const pt_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tratamento de conflitos`)
};

const zh_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲突处理`)
};

const tr_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çatışma yönetimi`)
};

const ru_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешение конфликтов`)
};

const pl_svchip_conflict_handling = /** @type {(inputs: Svchip_Conflict_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługa konfliktów`)
};

/**
* | output |
* | --- |
* | "Conflict handling" |
*
* @param {Svchip_Conflict_HandlingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_conflict_handling = /** @type {((inputs?: Svchip_Conflict_HandlingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Conflict_HandlingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_conflict_handling(inputs)
	if (locale === "bn") return bn_svchip_conflict_handling(inputs)
	if (locale === "de") return de_svchip_conflict_handling(inputs)
	if (locale === "es") return es_svchip_conflict_handling(inputs)
	if (locale === "fr") return fr_svchip_conflict_handling(inputs)
	if (locale === "pt") return pt_svchip_conflict_handling(inputs)
	if (locale === "zh") return zh_svchip_conflict_handling(inputs)
	if (locale === "tr") return tr_svchip_conflict_handling(inputs)
	if (locale === "ru") return ru_svchip_conflict_handling(inputs)
	if (locale === "pl") return pl_svchip_conflict_handling(inputs)
	return en_svchip_conflict_handling(inputs)
});